export default (minutes: number): number => {
  if (process.env.NO_CACHE) {
    return 0;
  } else {
    return minutes * 60 * 1000;
  }
};
